// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__ohJ-f","title":"Advt_title__rpsyK","qrBlock":"Advt_qrBlock__-Tjc2","qrCode":"Advt_qrCode__4m1y3"};